import { useContext } from 'react';
import FiltersContext from '../../shared/context/FiltersContext';

export default function useFilters() {
  return useContext(FiltersContext);
}
